import { Collection } from 'firestorter';

import { firestorePaths } from '../utils/firebasePaths';
import BaseDocument from './BaseDocument';

const CheckoutSessionOnboardingStatus = {
  CREATED: 'CREATED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE',
  ERROR: 'ERROR',
};

const CheckoutSessionOnboardingErrorCode = {
  DUPLICATE_COACH_ACCOUNT: 'DUPLICATE_COACH_ACCOUNT',
};

class CheckoutSessionOnboarding extends BaseDocument {
  constructor(id, opts) {
    super(`${firestorePaths.CHECKOUT_SESSION_ONBOARDING}/${id}`, opts);
  }

  get contractId() {
    return this.data.contractId;
  }

  get sessionId() {
    return this.data.stripeSessionId;
  }

  get status() {
    return this.data.status;
  }

  get url() {
    return this.data.url;
  }

  get urlExpiresAt() {
    return this.data.urlExpiresAt?.toDate();
  }

  get email() {
    return this.data.email;
  }

  get errorCode() {
    return this.data.errorCode;
  }

  get refunded() {
    return this.data.refunded;
  }

  /** Stamped by the server when the contract behind the session is an upsell off a running challenge. */
  get isUpsell() {
    return !!this.data.isUpsell;
  }

  static async getByContractAndSessionIds(contractId, sessionId) {
    const collection = new Collection(firestorePaths.CHECKOUT_SESSION_ONBOARDING, {
      createDocument: ({ id }, options) => new CheckoutSessionOnboarding(id, options),
      query: (query) => query
        .where('contractId', '==', contractId)
        .where('stripeSessionId', '==', sessionId),
    });
    await collection.fetch();
    return collection;
  }

  /**
   * Get CheckoutSessionOnboarding document by id.
   * @param {string} id - The document id.
   * @returns {Promise<CheckoutSessionOnboarding|null>} The document or null if it doesn't exist.
   */
  static async getById(id) {
    const doc = new CheckoutSessionOnboarding(id);
    await doc.init();
    return doc.exists ? doc : null;
  }
}

export default CheckoutSessionOnboarding;

export { CheckoutSessionOnboardingStatus, CheckoutSessionOnboardingErrorCode };
